import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserInterface } from "../../../interfaces/userInterface";
import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import { userApi } from "../services/user.api";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  USER_MESSAGES_ERROR,
  USER_MESSAGES_SUCCESS,
} from "../constants/messages";

export const useSaveUserMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ApiResponse<UserInterface>, Error, UserInterface>({
    mutationFn: (user) => userApi.saveUser(user),
    onSuccess: (res, variables) => {
      if (!res.ok) {
        errorNotification(USER_MESSAGES_ERROR.SAVE_ERROR);
        return;
      }
      successNotification(USER_MESSAGES_SUCCESS.SAVE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["users"] });
      if (variables._id) {
        queryClient.invalidateQueries({
          queryKey: ["user-by-id", variables._id],
        });
      }
    },
    onError: () => {
      errorNotification(USER_MESSAGES_ERROR.SAVE_ERROR);
    },
  });
};
